import type { FunctionalComponent } from 'preact';
import { SafeImage } from '@/components/safe-image.tsx';
import type { WebzineIssue } from '@/types/webzine.ts';

type Interview = NonNullable<WebzineIssue['interview']>;

interface Props {
  interview: Interview;
  open: boolean;
  onClose: () => void;
}

/** 인터뷰 전체보기 팝업 (시안 index.html 의 #interviewPopup, 다크 변형) */
export const InterviewPopup: FunctionalComponent<Props> = ({ interview, open, onClose }) => (
  <div
    class={
      open
        ? 'common-popup-overlay common-popup-overlay--dark is-open'
        : 'common-popup-overlay common-popup-overlay--dark'
    }
    onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}
  >
    <div class="common-popup common-popup--dark">
      <div class="popup-header">
        <button type="button" class="popup-close" aria-label="닫기" onClick={onClose}>
          <img src="/images/close.png" alt="" />
        </button>
      </div>
      <div class="popup-body">
        <div class="popup-detail is-open popup-detail--interview">
          <SafeImage class="popup-interview-photo" src={interview.photo} alt={interview.name} />
          <h1>{interview.full.heading}</h1>
          <p>
            {interview.full.body.map((paragraph, i) => (
              <>
                {i > 0 && (
                  <>
                    <br />
                    <br />
                  </>
                )}
                {paragraph}
              </>
            ))}
          </p>
        </div>
      </div>
    </div>
  </div>
);
